import GlobeMark from "./GlobeMark";

export default function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <a
              className="brand"
              href="#top"
              data-testid="footer-brand-link"
              aria-label="Global Citizen Consulting, Family Office Practice, back to top"
            >
              <GlobeMark />
              <span className="brand-text">
                <span className="brand-name">Global Citizen Consulting</span>
                <span className="brand-sub">Family Office</span>
              </span>
            </a>
            <p className="footer-note" data-testid="footer-note">
              The family office practice of Global Citizen Consulting, a
              jurisdictional strategy firm incorporated in the United States
              with offices in Panama City, Dallas, Dubai and Madrid.
            </p>
          </div>
          <nav
            className="footer-col"
            aria-label="The firm"
            data-testid="footer-firm"
          >
            <p className="footer-label">The firm</p>
            <a
              href="https://globalcitizenconsult.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-link-main"
            >
              Global Citizen Consulting
            </a>
            <a
              href="https://insights.globalcitizenconsult.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-link-insights"
            >
              Insights
            </a>
            <a href="#top" data-testid="footer-link-family-office">
              Family Office
            </a>
          </nav>
          <div className="footer-col" data-testid="footer-contact">
            <p className="footer-label">Contact</p>
            <a
              href="mailto:contact@globalcitizenconsult.com"
              data-testid="footer-email"
            >
              contact@globalcitizenconsult.com
            </a>
            <a href="tel:+18883227455" data-testid="footer-phone">
              +1 (888) 322-7455
            </a>
          </div>
        </div>
        <div className="footer-legal" data-testid="footer-legal">
          <p>© 2026 Global Citizen Consulting. All rights reserved.</p>
          <p>Built by the people whose names are on the door.</p>
        </div>
      </div>
    </footer>
  );
}
